// extracted by mini-css-extract-plugin
module.exports = {"styles":"_1Jd1V4qSAtSWklVWd4XM2D"};